import { Button, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { CheckboxElement, useWatch } from 'react-hook-form-mui';
import { makeStyles } from 'tss-react/mui';
import { helpText } from '../../../sic-lib/types/infoData';
import { QuickCreateContact } from '../../../sic-lib/types/QuickCreateContact';
import { ContactPrivacyTerms } from '../../Shared/Contact/ContactPrivacyTerms';

interface Props {
    parentRef: React.MutableRefObject<HTMLDivElement | null>;
}

export default function QuickCallConsent({ parentRef }: Props) {
    const { classes } = useStyles();
    const [isTermsOpen, setIsTermsOpen] = React.useState<boolean>(false);
    const formState = useWatch() as QuickCreateContact;

    console.log('formState', formState.pPolicy, formState.consent);

    React.useEffect(() => {
        if (formState.pPolicy && formState.consent) {
            setIsTermsOpen(true);
        }
    }, [formState.pPolicy, formState.consent]);

    const handleTermsOpen = () => {
        setIsTermsOpen(!isTermsOpen);
    };

    React.useEffect(() => {
        if (isTermsOpen) {
            /* scroll to the bottom of the consent if terms is open */
            parentRef.current && parentRef.current.scrollTo(0, parentRef.current.scrollHeight);
        }
    }, [isTermsOpen]);

    return (
        <Grid container spacing={2}>
            <Grid item>
                <Typography variant="subtitle1">Consents</Typography>
            </Grid>
            {helpText['Consents'].map(itm =>
                itm.title === 'terms' ? (
                    <React.Fragment key={itm.title}></React.Fragment>
                ) : (
                    <Grid item key={itm.title}>
                        <CheckboxElement name={itm.title} label={itm.paragraph} required />
                    </Grid>
                ),
            )}
            <Grid item>
                <Typography variantMapping={{ body1: 'span' }}>
                    <span style={{ color: 'red' }}>WARNING:</span> DO NOT check these boxes if you
                    don't have records of these confirmations. You agree to accept responsibility
                    for non-compliant communication practices, including fines or prosecution.
                </Typography>
            </Grid>
            <Grid item>
                <Button variant="text" onClick={handleTermsOpen}>
                    What are these?
                </Button>
            </Grid>
            {isTermsOpen && (
                <>
                    <Grid item>
                        <ContactPrivacyTerms />
                    </Grid>
                    <Grid item>
                        <CheckboxElement
                            name={helpText['Consents'][2].title}
                            label={helpText['Consents'][2].paragraph}
                            required
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
